import { Search, X } from 'lucide-react';

export const EMPTY_FILTER = { q: '', start: '', end: '', status: 'all' };

export function applyFilter(rows, f, page) {
  const q = f.q.trim().toLowerCase();
  return rows.filter(x => {
    if (f.start && x.due_date < f.start) return false;
    if (f.end && x.due_date > f.end) return false;
    if (f.status !== 'all' && x.status !== f.status && x.type !== f.status) return false;
    if (!q) return true;
    return [x.title, x.category, x.account, x.wholesaler_name, x.invoice_no, x.notes, x.payee, x.bank, x.serial_no].filter(Boolean).some(v => String(v).toLowerCase().includes(q));
  });
}

const STATUS_OPTIONS = {
  transactions: [['all', 'Tümü'], ['income', 'Gelir'], ['expense', 'Gider'], ['pending', 'Bekliyor'], ['completed', 'Tamamlandı']],
  invoices: [['all', 'Tümü'], ['unpaid', 'Ödenmedi'], ['paid', 'Ödendi']],
  notes: [['all', 'Tümü'], ['pending', 'Bekliyor'], ['completed', 'Tamamlandı']],
};

export function FilterBar({ page, filter, onChange, count, total }) {
  const set = (k, v) => onChange({ ...filter, [k]: v });
  const active = filter.q || filter.start || filter.end || filter.status !== 'all';
  return <div className="filter-bar" data-testid="filter-bar">
    <label className="filter-search"><Search size={14} /><input placeholder="Ara: açıklama, firma, fatura no…" value={filter.q} onChange={(e) => set('q', e.target.value)} data-testid="filter-search-input" /></label>
    <label>Başlangıç<input type="date" value={filter.start} onChange={(e) => set('start', e.target.value)} data-testid="filter-start-input" /></label>
    <label>Bitiş<input type="date" value={filter.end} onChange={(e) => set('end', e.target.value)} data-testid="filter-end-input" /></label>
    <label>Durum<select value={filter.status} onChange={(e) => set('status', e.target.value)} data-testid="filter-status-select">{(STATUS_OPTIONS[page] || STATUS_OPTIONS.notes).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></label>
    <span className="filter-count" data-testid="filter-count">{count} / {total} kayıt</span>
    {active && <button type="button" className="text-btn" onClick={() => onChange(EMPTY_FILTER)} data-testid="filter-clear-button"><X size={13} /> Temizle</button>}
  </div>;
}
